<template>
  <div id="app">
    <!-- <Top /> -->
    <!-- 路由匹配到的组件将渲染在这里 -->
    <router-view />
    <!-- <tab-bar v-if="showtab"></tab-bar> -->
  </div>
</template>

<script>
import watermark from './utils/waterMark.js'
// import Top from './components/top'
// import tabBar from './components/tabbar'
export default {
  name: 'App',
  //components: { tabBar, Top },
  data() {
    return {
      PPN: '',
      showtab: false,
      heightChange: true,
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
    }
  },
  created() {},
  mounted() {
    window.onresize = () =>
      (() => {
        this.showHeight = document.body.clientHeight
      })()
  },
  watch: {
    PPN() {},
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.heightChange = false
      } else {
        this.heightChange = true
      }
    },
    $route(val) {
      this.showtab = val.meta.showTab
      if (localStorage.getItem('user') && val.path != '/login') {
        this.PPN = JSON.parse(localStorage.getItem('user')).ppn
        watermark.set(this.PPN, document.documentElement)
      }
    },
  },
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  background-color: #f5f5f5;
  overflow: hidden;
  height: 100vh;
}

@media (prefers-color-scheme: dark) {
  body {
    background-color: #f5f5f5;
    color: #2c3e50;
  }
  #app {
    color: #2c3e50;
  }
}
// .appbox {
//   height: calc(100vh - 80px);
//   padding: 10px;
//   overflow-y: auto;
//   &.haveTab {
//     height: calc(100vh - 140px);
//   }
// }
#app {
  font-family: 'Porsche Next';
  color: #2c3e50;
  height: 100%;
}
</style>
